/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable import/prefer-default-export */
import {
    fontSize,
    paletteHD,
    enterpriseCSS,
    unitBase,
    rowSpacing,
} from './variables';

export const form = (typography, palette) => {
    const newPalette = !palette || !palette.cta1 ? paletteHD : palette;

    return {
        form: {
            // padding: rowSpacing,
            'padding-top': 0,
            '&.gift-list-pin-number': {
                margin: `${rowSpacing * 2}px auto`,
                padding: `0 ${rowSpacing * 2}px`,
                maxWidth: 500,
            },
            '&[disabled]': {
                position: 'relative',
                '&:before': {
                    content: '""',
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    display: 'block',
                    zIndex: 1,
                },
                '& > *': {
                    filter: 'grayscale(1)',
                    opacity: '0.6',
                },
            },

            '& .select-wrapper': { 'margin-bottom': 0 },

            '& .text-field-wrapper': {
                'margin-top': unitBase * 2,
                'margin-bottom': unitBase * 2,
                '& .input-label': {
                    'white-space': 'nowrap',
                    overflow: 'hidden',
                    '&.error': {
                        color: newPalette.error.main,
                        opacity: '0.7',
                    },
                },
                '& .input-field': {
                    fontSize: '1rem',
                },
            },
            '& .select-field-wrapper': {
                'margin-top': unitBase * 2,
                'margin-bottom': unitBase * 2,
            },
            '& .input-adorment.start': {
                marginRight: 0,
                '& p': {
                    color: palette.common?.black || '#000',
                    marginBottom: 2,
                    fontSize: '0.87em',
                },
            },
            '& .input-adorment.end': {
                '& p': {
                    'font-size': fontSize.small,
                    opacity: '0.7',
                    marginBottom: 0,
                },
                '& svg': {
                    width: '1.5em',
                },
            },
            '& .form-helper-text': {
                'margin-top': '8px !important',
                'margin-bottom': '0 !important',
                'font-size': '12px',
            },
            '& .order-number-adornment .input-adorment.start': {
                'margin-right': 0,
                '& > p': {
                    color: enterpriseCSS.palette.black,
                    fontSize: fontSize.component,
                    marginBottom: 0,
                },
            },
            '& .suggested-address-wrapper': {
                position: 'relative',
            },
            '& .suggested-address': {
                left: unitBase,
                top: '-6px',
                width: `calc(100vw - ${rowSpacing * 4}px - ${unitBase * 8}px)`,
                maxHeight: rowSpacing * 25,
                outline: 'none',
                position: 'absolute',
                'overflow-y': 'scroll',
                'border-bottom-left-radius': unitBase,
                'border-bottom-right-radius': unitBase,
                'background-color': '#fff',
                'z-index': 2,
                '-webkit-box-shadow':
                    '0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12)',
                '& > li': {
                    padding: `${unitBase * 2}px`, // trying to fit 7 suggested addresses in the dropdown
                    'margin-right': unitBase * 2,
                    overflow: 'hidden',
                    'white-space': 'nowrap',
                    fontSize: '14px',
                    minHeight: rowSpacing * 3,
                },
            },
            '& input[disabled]': {
                color: enterpriseCSS.palette.gray1,
                border: `1px solid ${newPalette.disableButton}`,
                'background-color': enterpriseCSS.palette.gray3,
            },
        },
    };
};
